<template>
  <v-container class="pt-0 pb-0">
    <v-row class="pa-0 mb-n11 mt-1">
      <v-col cols="9" class="d-flex flex-row">
      <v-text-field class="input-text-size pt-0 pb-0"
      :value="getSelectedTaxType" label="Tax Type" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0"
      :value="mainCompItem.taxYear" label="Tax Year" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0 mr-2"
        :value="mainCompItem.taxId" label="Tax ID" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0 mr-2" label="Base ID"
      :value="mainCompItem.baseId" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0"
      :value="mainCompItem.ownerId" label="Owner ID" readonly tabindex="-1" />
    </v-col>
    <v-col cols="3">
      <v-text-field class="input-text-size pt-0 pb-0" v-model="mainCompItem.propertyOrParcelId"
        label="Property/Parcel ID" readonly tabindex="-1" />
    </v-col>
    </v-row>
    <v-row class="row mt-n5">
      <v-col cols="3" class="pt-0 pb-0 mt-5">
        <CommonDropDowns
          :isItCategory=true @change="dataFromCommonDropDowns"
          :commentsCategoryValue="criteriaState.category" />
      </v-col>
    </v-row>
    <!-- dialogDynamicHeight="50vw" used to sit on the CRUDList below. CRUDList had no such
         prop, so Vue dropped it on the root div as a dead HTML attribute and it never did
         anything. CRUDList really has that prop now, so it would start sizing the small
         add/edit-comment dialog this list opens - and a 'vw' value used as a height makes
         that card taller than the screen. Parked here instead of going live by accident.
         The Comments tab itself is laid out by the record dialog around it (TaxInquiryDialog,
         sized from TaxrollTransactionList / OwnerTransactionList), not from here. -->
    <CRUDList
        ref="crudList"
        toolbarTitle="Tax Comments"
        :canAdd="true"
        :canEdit="true"
        :canSave="true"
        :canDeleteInDialog="isItCommentSeven || isTaxAdmin"
        :showSelect="true"
        :enableFixedHeaders="true"
        :displayTopPagination="false"
        :hideDefaultFooter="true"
        :disableKeyboardFunc="true"
        :headers="headers"
        :selectedItems="selectedItems"
        :baseCrudKey="baseCrudKey"
        :createNewItem="newItemDialog"
        :defaultSortBy="defaultSortBy"
        :newItemDialog="newItemDialog"
        :overrideValidation="true"
        :variableToChangeRowBgColor="[{ varName: 'isItCategorySeven', varCol: '#82B1FF' }]"
        tableWrapperDynamicClassname='taxroll-table-wrapper-two'
        tableDynamicHeight="200"
        dialogDynamicWidth='550'
        @upsertItem="upsertTaxComment"
        @deleteItem="deleteFromDiaglog"
        @loadCRUDList="handleLoadCommentList"
        @emitSelectedItem="emitSelectedItem"
      >
        <template v-slot:[`editedItem`]="{}">
          <commentDialog :baseCrudKey="baseCrudKey" :isItFromCommentList="true"
           :category="criteriaState.category"
         />
        </template>
      </CRUDList>

    <v-row dense class="mt-2">
      <v-col cols="4" class="pt-4">
        <v-btn color="primary" rounded dense small @click="printSelectedComment">
          Print Selected Comment
        </v-btn>
      </v-col>
      <v-col cols="4" class="pt-4">
        <v-btn color="primary" rounded dense small @click="printComment">
          Print All Comments
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {
  mapMutations, mapActions, mapState, mapGetters,
} from 'vuex';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import commentDialog from '../../TaxCommonComponents/commentDialog.vue';
import { commentsHeaders } from '../TaxInquiryUtils/TableHeaders.utils';
import { clients } from '../../../../util/clients';
import CommonDropDowns from '../../common-utils/CommonDropDowns.mixin.vue';
import { getRawJwt } from '../../../../util/jwt';
import { postProcessCommentsTrans } from '../../common-utils/CommonTaxFunctionalities';
import { getWorkstationNumber } from '../../../../util/workstation-util';
import { taxCommentTypesObj } from '../../common-utils/tax-common.util';
import '../../../../assets/style.css';
import { authRoles } from '../../../../router/roleGroups';
import { isAuthorised } from '../../../../store/auth/token';

const { backendRest } = clients.direct;
export default {
  name: 'CommentsTransactionList',
  components: {
    CRUDList,
    commentDialog,
    CommonDropDowns,
  },
  data() {
    return {
      baseCrudKey: 'commentsTransactionList',
      headers: commentsHeaders,
    };
  },
  computed: {
    ...mapGetters('auth/token', ['authUser']),
    ...mapState({
      StoreSelItems: (state) => state.tax.taxInquiryTabs.slectedComments,
      commentsCategory: (state) => state.base.crud.items.sharedTaxComments,
      TaxTypeEnum: (state) => state.enums.TaxTypeEnum,
    }),
    ...mapGetters('base/crud', ['criteria', 'items', 'item']),
    itemsGetter() {
      const itemData = this.item(this.baseCrudKey);
      return itemData;
    },
    mainCompItem: {
      get() {
        return this.item(this.mainCompBaseCrudKey);
      },
      set(value) {
        this.setItem([this.mainCompBaseCrudKey, value]);
      },
    },
    selectedItems: {
      get() {
        return this.StoreSelItems;
      },
      set(value) {
        this.setComments(value);
      },
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    isTaxAdmin() {
      return isAuthorised(authRoles.SuperAdmin) || isAuthorised(authRoles.TaxAdmin);
    },
    getSelectedTaxType() {
      const selVal = (this.TaxTypeEnum || []).find((ft) => ft.name === this.mainCompItem.taxType);
      if (selVal && selVal.name) return `${selVal.name} - ${selVal.description}`;
      return '';
    },
    defaultSortBy() {
      return [
        {
          column: 'createdAt',
          direction: 'desc',
        },
      ];
    },
    isItCommentSeven() {
      const selectedItem = this.itemsGetter;
      if (taxCommentTypesObj.userCommentCode === selectedItem.category) return true;
      return false;
    },
  },
  props: {
    selectedRowItem: {
      type: Object,
      default: () => {},
    },
    mainCompBaseCrudKey: {
      type: String,
      default: 'mainCompBaseCrudKey',
    },
  },
  methods: {
    ...mapMutations('tax/taxInquiryTabs', ['setComments']),
    ...mapActions('tax/taxComments', ['loadTaxComments', 'upsertTaxCommentTrans', 'deleteTaxComments']),
    emitSelectedItem(id) {
      this.selectedItems = id;
    },
    getAuthToken() {
      return getRawJwt();
    },
    urlEncodeObject(obj) {
      return new URLSearchParams(obj).toString();
    },
    handleLoadCommentList() {
      const { baseCrudKey, selectedRowItem } = this;
      if (selectedRowItem && selectedRowItem.taxYear && selectedRowItem.taxId) {
        const criteriaOfComments = this.criteriaState;
        if (criteriaOfComments.sortBy) {
          for (const item of (criteriaOfComments.sortBy || [])) {
            if (item.column === 'categoryName') item.column = 'category';
          }
        }
        const criteria = {
          taxYear: selectedRowItem.taxYear,
          taxId: selectedRowItem.taxId,
          ...criteriaOfComments,
        };
        this.loadTaxComments({ criteria, baseCrudKey, postProcessTrans: this.postProcessTrans })
          .then(() => {
            this.setDefaultSelectedItems();
          });
      }
    },
    deleteFromDiaglog(item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        const { baseCrudKey } = this;
        this.deleteTaxComments({ item, baseCrudKey });
      }
    },
    postProcessTrans(items) {
      const updatedItems = postProcessCommentsTrans(items, this.commentsCategory);
      return updatedItems;
    },
    async upsertTaxComment(item) {
      const wkst = getWorkstationNumber();

      const { baseCrudKey } = this;
      const updatedItem = { ...item };
      updatedItem.taxYear = this.selectedRowItem.taxYear;
      updatedItem.taxId = this.selectedRowItem.taxId;
      updatedItem.taxInquiryTransaction = this.selectedRowItem._id;
      updatedItem.category = item.category ? item.category : 9; // set default category as 9
      if (updatedItem.category === 9) {
        const userName = this.authUser;
        updatedItem.comment = `${item.comment} by user ${userName}, Wkst-${wkst}`;
      }
      delete updatedItem.categoryName;
      delete updatedItem.isItCategorySeven;
      await this.upsertTaxCommentTrans({
        item: updatedItem,
        baseCrudKey,
        postProcessTrans: this.postProcessTrans,
      }).then(() => {
        this.setDefaultSelectedItems();
      });
    },
    setDefaultSelectedItems() {
      this.$nextTick(() => {
        this.selectedItems = [];
      });
    },
    // *** below part is not needed, api name is different now
    // handleCategory() {
    //   if (this.commentsCategory.length === 0)
    // this.loadCommentCategory({ criteria: { status: 'ACTIVE' } });
    // },

    printSelectedComment() {
      const slectedObj = this.selectedItems.filter((el) => typeof el === 'object');

      const _ids = slectedObj.map((item) => item._id);
      const selectedIds = _ids.join();
      if (!selectedIds) {
        return;
      }

      const toDate = this.criteriaState.fromDate;
      const fromDate = this.criteriaState.toDate;

      const criteria = {
        _ids: selectedIds,
        token: this.getAuthToken(),
        toDate,
        fromDate,
      };
      const urlCriteria = this.urlEncodeObject(criteria);
      const to = `taxInquiry/comments?${urlCriteria}`;
      const toUrl = `${backendRest.defaults.baseURL}/${to}`;
      window.open(toUrl);
    },
    printComment() {
      const _ids = this.items(this.baseCrudKey).map((item) => item._id);

      if (_ids.length < 1) {
        return;
      }
      const toDate = this.criteriaState.fromDate;
      const fromDate = this.criteriaState.toDate;
      // need to pass only object id for send as a url selected items
      const category = this.criteriaState.category ? this.criteriaState.category.split('-')[0] : undefined;
      delete this.criteriaState.category;
      const selectedIds = _ids.join();
      const criteria = {
        _ids: selectedIds,
        token: this.getAuthToken(),
        toDate,
        fromDate,
        category,
      };
      const urlCriteria = this.urlEncodeObject(criteria);
      const to = `taxInquiry/comments?${urlCriteria}`;
      const toUrl = `${backendRest.defaults.baseURL}/${to}`;
      window.open(toUrl);
    },
    dataFromCommonDropDowns(val, whichField) {
      this.criteriaState[whichField] = val;
      this.handleLoadCommentList();
    },
    newItemDialog() {
      const itemData = this.item(this.mainCompBaseCrudKey);
      const newItem = {
        taxYear: itemData.taxYear,
        taxId: itemData.taxId,
        category: taxCommentTypesObj.userCommentCode,
        userName: this.authUser,
      };
      return newItem;
    },
  },
};
</script>
